import { Component, ViewChildren, QueryList, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { TicketAddressActions } from "./reducer/ticket-address.actions"
import { DisplayShoppingCart, Salutation, Address } from "../../../models"
import { TicketAddressForm } from './ticket-address-form/ticket-address-form.component';
import { SpanButton } from '../../../ui-helper';
import { AppState } from "../../../reducers";
import { Store } from '@ngrx/store';

@Component({
	selector: 'ticket-address',
	templateUrl: "./ticket-address.component.html",
	styles: [require("./ticket-address.component.scss")],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class TicketAddressComponent {

	@Input() set displayShoppingCart(displayShoppingCart: DisplayShoppingCart) {
		if (displayShoppingCart)
			this.displayTicketsPerTicketItemUuid = this.getDisplayTicketsPerTicketItemUuid(displayShoppingCart);
	}
	@Input() ticketAddresses: Record<string, Address>;

	@Output() hidePopup = new EventEmitter<boolean>();

	@ViewChildren(TicketAddressForm)
	ticketAddressForms: QueryList<TicketAddressForm>;

	protected displayTicketsPerTicketItemUuid: any = [];
	protected salutation = Salutation;
	protected allFormsValid = true;

	constructor(
		private store$: Store<AppState>,
		private ticketAddressActions: TicketAddressActions
	) {}

	protected updateValidities() {
		this.allFormsValid = this.ticketAddressForms.map(element => element.ticketAddressForm.valid).every(valid => valid === true);
	}

	protected presetOtherAdressesClicked() {
		const form = this.ticketAddressForms.first
		const address = this.convertFormControlsToAddressObject(form.ticketAddressForm.controls);
		let addressesMap: any = {}
		this.ticketAddressForms.forEach(ticketAddressForm =>
			this.setMapElementForTicketAddressData(
				ticketAddressForm.ticketItemUuid,
				Object.assign({}, address),
				addressesMap
			)
		)
		this.ticketAddresses = addressesMap;
	}

	protected setTicketAddressesClick() {
		this.setTicketAddresses();
		this.hidePopup.emit(true);
	}

	private setTicketAddresses() {
		let resultMap: any = {}
		this.ticketAddressForms.forEach(ticketAddressForm =>
			this.setMapElementForTicketAddressData(
				ticketAddressForm.ticketItemUuid,
				this.convertFormControlsToAddressObject(ticketAddressForm.ticketAddressForm.controls),
				resultMap
			)
		)
		this.store$.dispatch(this.ticketAddressActions.setTicketAddresses(resultMap));
	}
/* Currently this check isn't really necessary because the formValidation prevents addresses from beeing passed, where salutation isn't unset, if the rest is empty.
But we keep it in case we want to change that behavior. */
	private checkForEmptyValuesExceptSalutation(object){
		return Object.keys(object)
		.map(key => {
			if(key != "salutation") return object[key]
		})
		.filter(value => value != null && value != "")
		.length > 0;
	}

	private setMapElementForTicketAddressData(ticketItemUuid: string, ticketAddressData: any, resultMap: any) {
		const hasNotNullValues = this.checkForEmptyValuesExceptSalutation(ticketAddressData)
		if (ticketItemUuid && hasNotNullValues){
			resultMap[ticketItemUuid] = ticketAddressData;
		}
		return resultMap;
	}

	private convertFormControlsToAddressObject(addressFromForm: any) {
		return {
			salutation: addressFromForm.salutation.value,
			firstname: addressFromForm.firstname.value,
			lastname: addressFromForm.lastname.value,
			phoneNumber: addressFromForm.phoneNumber.value,
			companyName: addressFromForm.companyName.value,
			email: addressFromForm.email.value,
			street: addressFromForm.street.value,
			houseNumber: addressFromForm.houseNumber.value,
			postalCode: addressFromForm.postalCode.value,
			city: addressFromForm.city.value
		}
	}

	private getDisplayTicketsPerTicketItemUuid(shoppingCart) {
		let displayTicketData = [];
		if (shoppingCart.events) {
			shoppingCart.events.forEach(scEvent => scEvent.displayTickets
				.forEach(displayTicket => displayTicket.ticketItemUuids
					.forEach(ticketItemUuid => {
						const aggregate = Object.assign(
							{},
							displayTicket,
							{ ticketItemUuid },
							{ event: scEvent.event },
							{ latestTicketUpdateOrCreateDate: scEvent.latestTicketUpdateOrCreateDate },
						);
						delete aggregate.ticketItemUuids;
						displayTicketData.push(aggregate);
					})
				)
			);
		}
		const sortedDisplayTicketData = displayTicketData.sort((a, b) =>
		b.latestTicketUpdateOrCreateDate.localeCompare(a.latestTicketUpdateOrCreateDate) ||
		a.categoryType.localeCompare(b.categoryType) ||
		a.priceLevel.localeCompare(b.priceLevel) ||
		a.ticketItemUuid.localeCompare(b.ticketItemUuid));
		return sortedDisplayTicketData;
	}
}



// WEBPACK FOOTER //
// ./src/app/components/checkout-components/ticket-address/ticket-address.component.ts